import { useState } from 'react';

const SITE_PLAN_IMG =
  'https://storage.readdy-site.link/project_files/794dc72f-0fe0-459a-adfa-e9a96db79dda/7c318c1e-236e-4d04-a56f-b0007cb831ef_vela-bay-site-plan.png?v=832bd394505daf31e9a62b6198cefaf3';

export default function SitePlanSection() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section id="site-plan" className="py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        {/* Accordion Header */}
        <button
          type="button"
          onClick={() => setIsOpen((prev) => !prev)}
          className="w-full flex items-center justify-between bg-[#172C37] text-white px-6 py-5 rounded-2xl cursor-pointer hover:opacity-90 transition-opacity"
        >
          <div className="flex items-center gap-3">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-map-2-line text-lg text-amber-300" />
            </div>
            <h4
              className="text-lg md:text-xl font-bold tracking-widest uppercase"
              style={{ fontFamily: '"Cormorant Garamond", serif' }}
            >
              Vela Bay Site Plan
            </h4>
          </div>
          <div className="w-8 h-8 flex items-center justify-center">
            <i
              className={`ri-arrow-down-s-line text-2xl transition-transform duration-300 ${
                isOpen ? 'rotate-180' : 'rotate-0'
              }`}
            />
          </div>
        </button>

        {/* Accordion Content */}
        <div
          className={`overflow-hidden transition-all duration-500 ease-in-out ${
            isOpen ? 'max-h-[3000px] opacity-100 mt-4' : 'max-h-0 opacity-0 mt-0'
          }`}
        >
          <div className="rounded-2xl overflow-hidden border border-[#172C37]/10">
            <img
              src={SITE_PLAN_IMG}
              alt="Vela Bay Site Plan Layout Floor Plan Singapore Bayshore"
              title="Vela Bay Site Plan"
              className="w-full h-auto object-top"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
